/***
 * Cross-page invalidation for access-grant mutations.
 * TEM61510-22577 §6 — when any of Sites/Groups/Accounts/Device/Cloud Space
 * writes to the access-grant store, every surface that may display derived
 * state must refetch.
 *
 * Inactive queries (no mounted observer) are only marked stale here;
 * they refetch on next mount. Active queries refetch immediately.
 ***/

const SURFACE_KEY_PREDICATE = (oid) => (query) => {
    const key = query.queryKey?.[0];
    if (typeof key !== 'string') return false;
    return (
        key === `organization/${oid}/user` ||              // Accounts list + Sites merge
        key === `organization/${oid}/user/count` ||         // Accounts pagination
        key === `organization/${oid}/group` ||              // Groups + Sites merge
        key === `organization-center/${oid}/site` ||        // Sites list
        key === `organization/${oid}/site` ||               // Accounts editor Site Admin source (§6.1)
        key === `/v1.2/device` ||                           // Device list
        key === `/device` ||                                // Accounts editor Device Admin source (§6.1)
        key === `/v1.2/device/summary` ||                   // Device summary
        key === 'manageShareAccess' ||                      // Accounts shared-folder modal
        key === 'restricted_storage_users' ||               // Cloud Space limit modal peers
        key === 'unrestricted_storage_users' ||
        key === 'unrestricted_storage_users_with_seated'
    );
};

export const invalidateAccessGrant = (queryClient, oid) => {
    if (!queryClient || !oid) return;
    queryClient.invalidateQueries({queryKey: ['cloud_space_index', oid]});
    queryClient.invalidateQueries({predicate: SURFACE_KEY_PREDICATE(oid)});
};
